import { render, staticRenderFns } from "./salesReturnAccount.vue?vue&type=template&id=80ae2666"
import script from "./salesReturnAccount.vue?vue&type=script&lang=js"
export * from "./salesReturnAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports